<template>
  <BaseStatusBar
    :show_switcher="shouldShowSwitcher"
    :current_tab="current_tab"
    :icon="currentIcon"
    @switchTab="onSwitchTab"
  >
    <template v-slot:first_tab v-if="preorder.status == 'confirmed'">
      <h3>{{ formatDuration(accept_minutes_left) }}</h3>
      <p>{{ preorder.marketplace_order ? $t("preorder_status_bar.accept_desc") : $t("preorder_status_bar.accept_local")}}</p>
    </template>
     <template v-slot:first_tab v-else-if="preorder.status == 'editing'">
      <h3 class="editing-title">{{ $t("inside_status_bar.editing") }}</h3>
    </template>
    <template v-slot:first_tab v-else-if="preorder.status == 'creating'">
      <h3 class="editing-title">{{ $t("preorder_status_bar.creating") }}</h3>
    </template>
    <template v-slot:first_tab v-else-if="preorder.status == 'serving'">
      <h3 :class="{
        'negative-diff': serve_minutes_left < 0
      }">{{ formatDuration(serve_minutes_left) }}</h3>
      <p>
        {{
        preorder.is_delivery
        ? $t("preorder_status_bar.send_desc")
        : $t("preorder_status_bar.serve_desc")
        }}
      </p>
    </template>
    <template v-slot:first_tab v-else>
      <h3>
        {{
        preorder.is_delivery
        ? $t("preorder_status_bar.sent")
        : $t("preorder_status_bar.served")
        }}
      </h3>
      <!-- <p>До видачі</p> -->
    </template>
    <template v-slot:second_tab v-if="isOrderPaid">
      <h3 class="status-paid">{{ $t('preorder_status_bar.paid') }}</h3>
      <p>{{ $t("preorder_status_bar.pay_status") }}</p>
    </template>
    <template v-slot:second_tab v-else>
      <h3 class="status-unpaid">{{ $t('preorder_status_bar.unpaid') }}</h3>
      <p>{{ $t("preorder_status_bar.pay_status") }}</p>
    </template>
  </BaseStatusBar>
</template>

<script>
import BaseStatusBar from "@/components/statusbar/BaseStatusBar.vue";

import moment from "moment";

export default {
  props: {
    preorder: Object,
  },
  data() {
    return {
      current_tab: 0,
      accept_minutes_left: 0,
      serve_minutes_left: 0,
    };
  },
  methods: {
    onSwitchTab() {
      if (!this.shouldShowSwitcher) return;

      if (this.current_tab == 0) {
        this.current_tab = 1;
      } else {
        this.current_tab = 0;
      }
    },
    tickAcceptTimer() {
      if (this.preorder.status != "confirmed") return;

      const now = moment();

      const max_date = moment(
        this.preorder.delayed_to || this.preorder.confirmed_at
      ).add(15, "minutes");

      if (this.preorder.marketplace_order) {
        this.accept_minutes_left = max_date.diff(now, "minutes");
      } else {
        this.accept_minutes_left = moment().diff(
          this.preorder.confirmed_at,
          "minutes"
        );
      }

      if (this.accept_minutes_left > 0) {
        setTimeout(this.tickAcceptTimer, 30 * 1000);
      }
    },
    tickServeTimer() {
      if (this.preorder.status != "serving") return;

      const now = moment();
      const max_date = moment(this.preorder.serve_date);

      this.serve_minutes_left = max_date.diff(now, "minutes");

      if (this.serve_minutes_left > 0) {
        setTimeout(this.tickServeTimer, 30 * 1000);
      }
    },
    formatDuration(mins) {
      if (mins == 0) {
        return `0 ${this.$t('waiting.time')}`;
      }

      let hours = Math.abs(Math.floor(mins / 60));
      let remainder = Math.abs(mins) % 60;

      let result = '';

      if (mins < 0) result = '-';

      if (hours > 0) {
        result += `${hours} ${this.$t('waiting.hours')} `;
      }

      if (remainder > 0) {
        result += `${remainder} ${this.$t('waiting.time')}`;
      }

      return result;
    }
  },
  mounted() {
    this.tickAcceptTimer();
    this.tickServeTimer();

    if (this.preorder.status == "closed" || this.preorder.status == 'cancelled') {
      this.current_tab = 1;
    }
  },
  computed: {
    shouldShowSwitcher() {
      return (
        !['confirmed', 'editing', 'closed', 'creating', 'cancelled'].includes(this.preorder.status)
      );
    },
    currentIcon() {
      if (this.current_tab == 1) {
        return this.isOrderPaid
          ? "/icons/status-payment-green.svg"
          : "/icons/status-payment-red.svg";
      }

      if (this.preorder.status == 'editing' || this.preorder.status == 'creating') {
        return "/icons/pencil-yellow.svg";
      }

      if (this.preorder.status == "serving") {
        return "/icons/status-processing.svg";
      }

      if (this.preorder.status == "confirmed") {
        return "/icons/warning.svg";
      }

      if (this.preorder.status == "unpaid") {
        if (this.preorder.is_delivery) {
          return "/icons/car.svg";
        } else {
          return "/icons/status-claimed.svg";
        }
      }
    },
    // isOrderPaid() {
    //   if (this.preorder.status == "cancelled") return false;
    //   if (this.preorder.status == "closed") return true;
    //   if (this.preorder.paid_by_bonuses) return true;

    //   if (this.preorder.status == "unpaid") {
    //     if (this.preorder.is_delivery) {
    //       return "/icons/car.svg";
    //     } else {
    //       return "/icons/status-claimed.svg";
    //     }
    //   }
    // },
    isOrderPaid() {
      if (this.preorder.status == "closed") return true;
      if (this.preorder.paid_by_bonuses) return true;

      return this.preorder.pay_method == "online";
    },
  },
  components: {
    BaseStatusBar,
  },
};
</script>

<style scoped>
.status-paid {
  color: #129b81 !important;
}

.status-unpaid {
  color: #e2223b !important;
}

.negative-diff {
  color: #e2223b !important;
}

h3.editing-title {
  color: #ffd2a8;
}
</style>
